/**
 * STİL TOKENLARININ değerleri (M4 §3.7.3 "Stil"): köşe, gölge, yazı tipi.
 *
 * **Çekirdekte çünkü İKİ taraf aynı şeyi çizmek zorunda:** ziyaretçinin gördüğü widget ve
 * PANELDEKİ önizleme. Panelde 16 piksel köşe gösterip ziyaretçiye 24 piksel çizmek, işletmeye
 * kurduğundan başka bir ekran göstermek olurdu — ve bunu kimse fark etmez. Karşıtlık hesabı
 * (`contrast.ts`) tam bu gerekçeyle buraya taşınmıştı; bu dosya onun yanına geliyor.
 *
 * **Sunucu yalnız ADI saklıyor,** değeri hiç bilmiyor: ad bir ölçek üyesi, değer bir çizim
 * ayrıntısı. Değerleri API sözleşmesine taşımak, CSS'i belgeye yazmak olurdu.
 *
 * **Tanınmayan ad VARSAYILANA düşüyor.** Değer sunucudan geliyor ve eski bir istemci yeni bir
 * adı görebilir; hata göstermenin anlamı yok, düşmek pencereyi hiç çizmemekten iyi. Sunucu
 * tarafı tersine davranıyor ve orası da doğru: işletmeye kaydettiğini sandığı ama olmayan bir
 * ayar bırakmamak için reddediyor.
 *
 * Hesap saf: ne I/O var ne tarayıcı. Aynı kod panelde ve ziyaretçinin tarayıcısında koşuyor.
 */

/**
 * KÖŞE ölçeği, piksel.
 *
 * Değerler SAYI (dize değil): bu tablo widget paketine giriyor ve `'16px'` yazmak her girdide
 * iki tırnak artı iki karakter demekti. Ölçek sekizin katları — "yarısı / bugünkü / bir buçuğu"
 * ilişkisi gözle de okunuyor.
 */
export const CORNER_PX: Record<string, number> = { none: 0, small: 8, medium: 16, large: 24 };

/** Ölçek dışı ad bununla çiziliyor; bugünkü görünüm. */
export const DEFAULT_CORNER_PX = 16;

export const cornerPx = (name: string | undefined): number =>
  CORNER_PX[name ?? ''] ?? DEFAULT_CORNER_PX;

/** Ürünün yazı tipi yığını; harici font YÜKLENMİYOR (şartnamenin açık koşulu). */
export const SYSTEM_FONT = 'system-ui,-apple-system,"Segoe UI",sans-serif';

/**
 * `inherit` sitenin yazı tipini devralıyor; başka her ad sistem yığınına düşüyor.
 *
 * İki seçenek, üç değil: üçüncüsü (harici font) bir dosya indirmek ve çoğu zaman bir üçüncü
 * tarafa IP sızdırmak demek.
 */
export const fontStack = (name: string | undefined): string =>
  name === 'inherit' ? 'inherit' : SYSTEM_FONT;
